import moment from 'moment-timezone'

export const getArrayMontly = function(label, data) {
  let items = []
  for (let month = 1; month <= 12; month++) {
    let labelMonth = label + (month < 10 ? '0' : '') + month
    let val = data[labelMonth] != undefined ? +data[labelMonth] : 0
    items.push(val)
  }
  return items
}

export const buildSeries = function(type, statistics, year) {
  if (type == 'statusYearly') {
    let series = []
    if (
      statistics.total_pendientes != undefined &&
      statistics.total_en_proceso != undefined &&
      statistics.total_firmados != undefined &&
      statistics.total_expirados != undefined
    ) {
      series = [statistics.total_pendientes, statistics.total_en_proceso, statistics.total_firmados, statistics.total_expirados]
    } 
    return [
      {
        name: '',
        data: series
      }
    ]
  }

  const toShow = monthsToShow(year)

  if (type == 'statusMonthly') {
    return [
      {
        name: 'Pendiente',
        data: sliceArray(statistics.pendientes, toShow)
      },
      {
        name: 'En Proceso',
        data: sliceArray(statistics.enproceso, toShow)
      },
      {
        name: 'Firmados',
        data: sliceArray(statistics.firmados, toShow)
      },
      {
        name: 'Expirado',
        data: sliceArray(statistics.expirados, toShow)
      }
    ]
  }

  return sliceArray(statistics.creados, toShow)
}

export const buildOptions = function(
  type,
  statisticsColors,
  statisticsLabelsMonthly,
  year
) {
  if (type == 'statusYearly') {
    return {
      chart: {
        type: 'bar',
        toolbar: {
          show: false
        }
      },
      colors: statisticsColors,
      plotOptions: {
        bar: {
          borderRadius: 6,
          distributed: true
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: [['Pendientes'], ['En Proceso'], ['Firmado'], ['Expirado']]
      },
      yaxis: {
        labels: {
          formatter: function(val) {
            return val
          }
        }
      },
      noData: {
        text: 'En esta gráfica verás reflejado por año los documentos firmados o en proceso de firma.',
        style: {
          fontSize:'13px'
        }
      }
    }
  }

  const toShow = monthsToShow(year)

  if (type == 'statusMonthly') {
    return {
      chart: {
        type: 'bar',
        toolbar: {
          show: false
        },
        animations: {
          dynamicAnimation: {
            enabled: false
          }
        }
      },
      colors: statisticsColors,
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 6
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: sliceArray(statisticsLabelsMonthly, toShow)
      },
      yaxis: {
        labels: {
          formatter: function(val) {
            document.getElementsByTagName('tspan').forEach(element => {
              if(element.textContent == 'Infinity')
                element.textContent = '1'
            })
            return val.toFixed(0);
          }
        }
      },
      noData: {
        text: 'Los documentos por mes se reflejarán en esta gráfica.'
      }
    }
  }

  return {
    chart: {
      type: 'pie'
    },
    colors: statisticsColors,
    labels: sliceArray(statisticsLabelsMonthly, toShow),
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        return opts.w.globals.series[opts.seriesIndex]
      }
    },
    tooltip: {
      y: {
        formatter: function(val, opts) {
          return Number.parseFloat(opts.globals.seriesPercent[opts.seriesIndex]).toFixed(2) + '%'
        }
      }
    },
    noData: {
      text: 'Aún no tienes suficiente información para generar esta estadística.'
    }
  }
}

function sliceArray(data, toShow) {
  if (data != undefined && data.length >= toShow) {
    return data.slice(0, toShow)
  }
  return []
}

function monthsToShow(year) {
  return year == moment().year() ? moment().month() + 1 : 12
}
